import React, { useEffect, useState } from 'react';
import { Image, Row, Col, Card, Button, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import DropdownEditCustomer from '../../components/Dropdown/DropdownEditCustomer';
import { getDataUser } from '../Profile/ProfileSlice';
import { allCustomerInfos, getDataCustomers } from './CustomersSlice';
// image
import defaultLogo from '../../assets/images/avatar.png';
import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import ModalAddCustomer from '../../components/Modal/ModalAddCustomer';
import * as Icon from 'react-feather';

//Table ant design
import { Table } from 'ant-table-extensions';
import { SearchOutlined } from '@ant-design/icons';

const Customers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const dataCustomers = useSelector(allCustomerInfos);
  const customerStatus = useSelector((state) => state.customers.status);

  const [isMaximize, setMaximize] = useState(false);
  const [changeIcon, setChangeIcon] = useState(true);

  const [curPage, setCurPage] = useState(1);
  const [pagination, setPagination] = useState({
    current: curPage,
    pageSize: 10,
    total: 10,
  });

  const [loading, setLoading] = useState(false);
  const [isModalAddCustomer, setIsModalAddCustomer] = useState(false);

  useEffect(() => {
    dispatch(getDataUser(token));
  }, [token, dispatch]);

  useEffect(() => {
    const pageSize = pagination.pageSize;
    const page = pagination.current - 1;
    dispatch(getDataCustomers({ token, pageSize, page }));
  }, [dispatch]);

  useEffect(() => {
    if (customerStatus === 'loading') {
      setLoading(true);
    } else {
      setPagination({ ...pagination, total: dataCustomers?.totalElements });
      setLoading(false);
    }
  }, [customerStatus]);

  if (customerStatus === 'success') {
    const pageSize = pagination.pageSize;
    const page = pagination.current - 1;
    dispatch(getDataCustomers({ token, pageSize, page }));
    setLoading(false);
  }

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      render: (customerId) => <DropdownEditCustomer customerId={customerId} />,
      width: 200,
    },
    {
      title: '',
      dataIndex: 'image',
      key: 'image',
      render: (avatar) => (
        <Image
          width={40}
          height={40}
          src={avatar ? avatar : defaultLogo}
          style={{ borderRadius: '10px', objectFit: 'scale-down' }}
        />
      ),
      width: 60,
    },
    {
      title: t('customer').toUpperCase(),
      dataIndex: 'customer',
      key: 'customer',
      render: ([deviceId, title, quantity]) => (
        <Link to={`/device/${deviceId}`}>
          <span style={{ fontWeight: 'bold' }}>
            {title} <br />
            <span style={{ color: '#888' }}>
              {quantity} {t('filter-station')}
            </span>
          </span>
        </Link>
      ),
      sorter: (a, b) => a?.customer?.[1]?.localeCompare(b?.customer?.[1]),
      sortDirections: ['ascend', 'descend'],
      width: 300,
    },
    {
      title: t('phone').toUpperCase(),
      dataIndex: 'phone',
      key: 'phone',
      sorter: (a, b) => a?.phone?.localeCompare(b?.phone?.charAt(0)),
      sortDirections: ['ascend', 'descend'],
      width: 250,
    },
    {
      title: 'Email'.toUpperCase(),
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a?.email?.localeCompare(b?.email),
      sortDirections: ['ascend', 'descend'],
      width: 250,
    },
    {
      title: t('address').toUpperCase(),
      dataIndex: 'address',
      key: 'address',
      sorter: (a, b) => a?.address?.localeCompare(b?.address),
      sortDirections: ['ascend', 'descend'],
      width: 300,
    },
  ];

  const data = dataCustomers.data?.map((item, idx) => ({
    key: idx,
    index: item.id.id,
    image: item.avatar ? item.avatar.value : undefined,
    customer: [item.id.id, item.title, item.device.length],
    phone: item.phone,
    email: item.email,
    address: item.address,
  }));

  const handleTableChange = (pagination, filters, sorter) => {
    if (curPage !== pagination.current) {
      const pageSize = pagination.pageSize;
      const page = pagination.current - 1;
      dispatch(getDataCustomers({ token, pageSize, page }));
      setCurPage(pagination.current);
    }
    setPagination(pagination);
  };

  // Extend card
  const extendCard = () => {
    var card = document.getElementById('card');

    setMaximize(!isMaximize);
    if (card.classList.contains('card-extend'))
      card.classList.remove('card-extend');
    else card.classList.add('card-extend');
  };

  // Reload card
  const reload = () => {
    var card = document.getElementById('card');
    card.classList.add('card-load');
    var div = document.createElement('div');
    var i = document.createElement('i');
    div.classList.add('card-loader');
    div.id = 'loader';
    i.classList.add('pct-loader1');
    i.classList.add('anim-rotate');
    div.appendChild(i);
    card.appendChild(div);
    setTimeout(() => {
      card.removeChild(div);
      card.classList.remove('card-load');
    }, 3000);
  };

  return (
    <section className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs floor={[{ name: t('customer') }]} />
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <Row>
                  <Col>
                    <Card id="card">
                      <Card.Header>
                        <h5>{t('customer-management')}</h5>
                        <div className="card-header-right">
                          <Dropdown
                            id="dropdown"
                            onToggle={() => setChangeIcon(!changeIcon)}
                          >
                            <Dropdown.Toggle variant="none" id="dropdown-basic">
                              {changeIcon ? (
                                <i className="feather icon-more-horizontal"></i>
                              ) : (
                                <i className="feather icon-chevron-down"></i>
                              )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {!isMaximize ? (
                                <Dropdown.Item
                                  onClick={() => {
                                    extendCard();
                                  }}
                                >
                                  <Icon.Maximize size={16} /> {t('extend')}
                                </Dropdown.Item>
                              ) : (
                                <Dropdown.Item
                                  onClick={() => {
                                    extendCard();
                                  }}
                                >
                                  <Icon.Minimize size={16} /> {t('restore')}
                                </Dropdown.Item>
                              )}
                              <Dropdown.Item
                                onClick={() => {
                                  reload();
                                }}
                              >
                                <Icon.RefreshCw size={16} /> {t('reload')}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Card.Header>
                      <Card.Body id="cardBody">
                        <Button
                          variant="primary"
                          onClick={() => setIsModalAddCustomer(true)}
                          style={{ margin: '0 15px 10px', float: 'left' }}
                        >
                          + {t('add-new')}
                        </Button>
                        <Table
                          columns={columns}
                          dataSource={data}
                          pagination={pagination}
                          loading={loading}
                          onChange={handleTableChange}
                          scroll={{ x: true }}
                          searchableProps={{
                            inputProps: {
                              placeholder: t('search-table'),
                              prefix: <SearchOutlined />,
                              style: {
                                maxWidth: '350px',
                                padding: '6px',
                                borderRadius: '5px',
                              },
                            },
                            fuzzySearch: true,
                          }}
                        />
                        <ModalAddCustomer
                          show={isModalAddCustomer}
                          setShow={setIsModalAddCustomer}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Customers;
